<template>
  <v-row justify="center" align="center">
    <v-col cols="12" md="12" sm="12">
      <v-banner icon="lock">
        Change Password
        <template v-slot:actions>
          <v-btn text color="blue darken-2" exact @click="$router.go(-1)">
            <v-icon left>arrow_back</v-icon>Back
          </v-btn>
        </template>
      </v-banner>
    </v-col>
    <v-col cols="12" md="6" sm="12">
      <v-form v-model="valid" v-click-outside="hideCapsWarning">
        <div
          id="password"
          v-on:keydown="capsLockState"
          v-on:click="capsLockStateClick"
        >
          <v-text-field
            v-model="password"
            outlined
            :rules="[
              required('Password'),
              maxLength('Password'),
              minLength('Password'),
            ]"
            prepend-inner-icon="lock"
            label="New Password"
            type="password"
          ></v-text-field>
        </div>

        <div class="capsLock" v-show="capsPassword">
          <span
            ><v-icon small class="alertIcon" color="warning"> mdi-alert</v-icon>
            Warning: Caps Lock On</span
          >
        </div>

        <div
          id="passwordConfirm"
          v-on:keydown="capsLockState"
          v-on:click="capsLockStateClick"
        >
          <v-text-field
            v-model="confirmPassword"
            :rules="[required('Confirm Password'), passwordConfirmationRule]"
            label="Confirm Password"
            outlined
            prepend-inner-icon="lock"
            type="password"
            :disabled="!password"
          ></v-text-field>
        </div>

        <div class="capsLock" v-show="capsConfirmPassword && password">
          <span
            ><v-icon small class="alertIcon" color="warning"> mdi-alert</v-icon>
            Warning: Caps Lock On</span
          >
        </div>
        <v-btn
          id="updateBtn"
          block
          x-large
          color="primary"
          @click.stop="changePassword"
          :disabled="!valid"
          >Update Password</v-btn
        >
      </v-form>
    </v-col>
  </v-row>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "ChangePassword",
  data: () => {
    return {
      valid: false,
      password: "",
      confirmPassword: "",
      capsPassword: null,
      capsConfirmPassword: null,
      required(fieldName) {
        return (v) => (v && v.length > 0) || `${fieldName} Required`;
      },
      maxLength(fieldName) {
        return (v) =>
          (v && v.length < 25) ||
          `${fieldName} must be less than 25 characters`;
      },
      minLength(fieldName) {
        return (v) =>
          (v && v.length > 3) || `${fieldName} must be more than 3 characters`;
      },
    };
  },

  computed: {
    ...mapGetters(["retrieveUser"]),
    passwordConfirmationRule() {
      return () =>
        this.password === this.confirmPassword || "Password must match";
    },
  },
  methods: {
    ...mapActions(["updatePassword", "setSnackbar"]),

    capsLockStateClick: function (event) {
      const field = event.currentTarget.id;

      this.lastInputField = field;
      const modifierState = event.getModifierState("CapsLock");
      if (field == "password") {
        this.capsPassword = modifierState;
        this.capsConfirmPassword = false;
      } else if (field == "passwordConfirm") {
        this.capsConfirmPassword = modifierState;
        this.capsPassword = false;
      }
    },

    //The caps lock remains stuck on true if we call getModifierState
    //on caps lock keydown
    capsLockState: function (event) {
      if (event.key == "CapsLock") {
        const field = event.currentTarget.id;
        if (field == "password") {
          this.capsPassword = !this.capsPassword;
        } else if (field == "passwordConfirm") {
          this.capsConfirmPassword = !this.capsConfirmPassword;
        }
      }
    },

    hideCapsWarning: function (event) {
      this.capsPassword = false;
      this.capsConfirmPassword = false;
    },

    changePassword() {
      this.error = false;
      this.errorMessage = "";
      const rec = Object.assign(
        {},
        { userId: this.retrieveUser.userNum },
        { sessionKey: this.retrieveUser.sessionKey },
        { password: this.password }
      );
      this.updatePassword(rec)
        .then((response) => {
          if (response.success == true) {
            this.password = "";
            this.confirmPassword = "";
            this.setSnackbar({ text: "Password Updated" });
            this.$router.push({ name: "UserAccount" });
          } else {
            this.setSnackbar({ text: response.message, color: "error" });
          }
        })
        .catch((er) => {
          console.log(er);
        });
    },
  },
};
</script>
<style scoped>
.capsLock {
  width: 270px;
  font: small-caption;
  font-size: 16px;
  color: #fb8c00;
  margin-top: -5px;
  margin-bottom: 10px;
}

/*So it stays perfectly aligned with the W letter*/
.alertIcon {
  margin-top: -3px;
}
</style>
